import React from "react";
import "./TalentLenzOpportunitySpecificSuitability.css";

import talentlenzOpportunitySpecificSuitabilityModel from "../../images/talentlenz-opportunity-specific-suitability-model.svg";
import talentlenzOpportunitySpecificSuitabilityTechnicalCompetencyIcon from "../../images/talentlenz-opportunity-specific-suitability-technical-competency-icon.svg";
import talentlenzOpportunitySpecificSuitabilityWorkplaceAwarenessIcon from "../../images/talentlenz-opportunity-specific-suitability-workplace-awareness-icon.svg";
import talentlenzOpportunitySpecificSuitabilityProfileValidityIcon from "../../images/talentlenz-opportunity-specific-suitability-profile-validity-icon.svg";

export default function TalentLenzOpportunitySpecificSuitability() {
  return (
    <section className="talentlenz-opportunity-specific-suitability" id="talentlenz-opportunity-match" aria-labelledby="talentlenz-opportunity-specific-suitability-title">
      <div className="talentlenz-opportunity-specific-suitability__inner">
        <div className="talentlenz-opportunity-specific-suitability__heading">
          <p className="talentlenz-opportunity-specific-suitability__eyebrow">MATCH THE OPPORTUNITY</p>
          <h2 id="talentlenz-opportunity-specific-suitability-title">Suitability is built from evidence—not keywords.</h2>
        </div>
    
        <div className="talentlenz-opportunity-specific-suitability__body-column">
          <p className="talentlenz-opportunity-specific-suitability__body">TalentLenz evaluates technical competency, workplace awareness and profile validity against the opportunity your team defined. The result is an opportunity-specific suitability score with the contributing evidence visible.</p>
          <p className="talentlenz-opportunity-specific-suitability__principle">The same person can suit one opportunity—and not another.</p>
        </div>
    
        <div className="talentlenz-opportunity-specific-suitability__desktop-model">
          <img src={talentlenzOpportunitySpecificSuitabilityModel} alt="Technical competency, workplace awareness and profile validity contributing to an illustrative opportunity-specific suitability score of 86" />
        </div>
    
        <div className="talentlenz-opportunity-specific-suitability__mobile-model" aria-label="Opportunity-specific evidence model">
      <div className="talentlenz-opportunity-specific-suitability__evidence-list">
        <div className="talentlenz-opportunity-specific-suitability__evidence-card">
          <img src={talentlenzOpportunitySpecificSuitabilityTechnicalCompetencyIcon} alt="" aria-hidden="true" />
          <strong>Technical competency</strong>
          <span>Opportunity-specific assessment evidence</span>
        </div>
        <div className="talentlenz-opportunity-specific-suitability__evidence-card">
          <img src={talentlenzOpportunitySpecificSuitabilityWorkplaceAwarenessIcon} alt="" aria-hidden="true" />
          <strong>Workplace awareness</strong>
          <span>Configured for the role; not psychometric</span>
        </div>
        <div className="talentlenz-opportunity-specific-suitability__evidence-card">
          <img src={talentlenzOpportunitySpecificSuitabilityProfileValidityIcon} alt="" aria-hidden="true" />
          <strong>Profile validity</strong>
          <span>Evidence extracted from submitted documents</span>
        </div>
      </div>
      <div className="talentlenz-opportunity-specific-suitability__score-panel">
        <div className="talentlenz-opportunity-specific-suitability__score-ring">
          <span>SUITABILITY</span>
          <strong>86</strong>
        </div>
        <p className="talentlenz-opportunity-specific-suitability__score-label">Opportunity-specific—not a generic candidate score.</p>
      </div>
    </div>
      </div>
    </section>
  );
}
